import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const TabRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${rawColors.text.lowEmphasis};
`;

export const SectionTitle = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const TableFrame = styled.div`
  width: 100%;
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  overflow: hidden;
`;

export const TableColumns = styled.div`
  display: flex;
  width: 100%;
`;

/** Figma ~58% title / 42% date within the 276px table frame. */
export const TitleColumn = styled.div`
  flex: 0 0 58%;
  min-width: 0;
`;

export const DateColumn = styled.div`
  flex: 0 0 42%;
  min-width: 0;
`;

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: ${spacing[3]} ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  ${typographyMixin("overline", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const BodyCell = styled.div<{ $isLast?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 42px;
  min-width: 0;
  padding: ${spacing[3]} ${spacing[2]};
  border-bottom: ${({ $isLast }) =>
    $isLast ? "none" : `${borderWidth[1]} solid ${rawColors.stroke[200]}`};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  overflow: hidden;
`;

export const LinkedTitle = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.primary[500]};
  text-decoration: underline;
  cursor: pointer;
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Button reset — when rendered as="button" */
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  &:hover { opacity: 0.8; }
`;

export const EmptyHint = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;
